import { createContext, type ReactElement, type ReactNode, useContext } from 'react';
import { type RuntimeConfig } from './runtime';

export type { RuntimeConfig } from './runtime';

export const RuntimeContext = createContext<RuntimeConfig | null>(null);

export const useRuntimeConfig = () => {
    const context = useContext(RuntimeContext);

    if (!context) {
        throw new Error('missing runtime context');
    }

    return context;
};

export type RuntimeProviderProps = {
    runtime: RuntimeConfig;
    children: ReactElement | ReactNode;
};

export const RuntimeProvider = ({ runtime, children }: RuntimeProviderProps) => (
    <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>
);
